import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';

export class ApplicationProfileService extends BaseHTTPClient {
  public static async getApplicationProfiles() {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/application-profiling/applications`,
      method: APIType.GET,
    });
  }

  public static async deleteApplicationProfile(id: string) {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/application-profiling/applications/${id}`,
      method: APIType.DELETE,
    });
  }

  public static async createApplicationProfile(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/application-profiling/composite-application-profile`,
           method: APIType.POST,
           data: payload,
        });
  }

  public static async updateApplicationProfile(id: string, payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/application-profiling/composite-application-profile/${id}`,
            method: APIType.PUT,
            data: payload,
        });
  }

  public static async getTestType() {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/application-profiling/test-types`,
      method: APIType.GET,
    });
  }

  public static async getBusinessUnits() {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/application-profiling/business-units`,
      method: APIType.GET,
    });
  }

  public static async getCompositeApplicationProfile(id: string) {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/application-profiling/composite-application-profile/${id}`,
      method: APIType.GET,
    });
  }
}
